import { gql, useQuery, useLazyQuery } from '@apollo/client';
import { DocumentTypesEnum } from '@thinknet-gmbh/platform-common';

import { FILETYPES } from 'src/components/document-files-list/document-files-list.constants';
import { downloadCurrentTemplate } from 'src/components/document-files-list/document-files-list.helpers';

export const GET_DOCUMENT_TEMPLATE_PREVIEW_BY_ID = gql`
  query getDocumentTemplatePreviewById(
    $documentTemplateId: ObjectId!
    $memberId: ObjectId
    $filetype: DocumentTypesEnum!
    $isMemberOwnDoc: Boolean
  ) {
    getDocumentTemplatePreviewById(
      documentTemplateId: $documentTemplateId
      memberId: $memberId
      filetype: $filetype
      isMemberOwnDoc: $isMemberOwnDoc
    ) {
      base64
      filetype
    }
  }
`;

export const useGetDocumentTemplatePdfPreviewById = (
  documentTemplateId: string,
  employeeId?: string,
  isMemberOwnDoc?: boolean
) => {
  const { data, loading, refetch } = useQuery(GET_DOCUMENT_TEMPLATE_PREVIEW_BY_ID, {
    variables: {
      documentTemplateId,
      memberId: employeeId,
      isMemberOwnDoc,
      filetype: DocumentTypesEnum.PDF,
    },
    skip: !documentTemplateId,
    fetchPolicy: 'no-cache',
  });
  const getDocumentTemplatePreviewById = data?.getDocumentTemplatePreviewById?.base64 || '';

  return { pdfBase64: getDocumentTemplatePreviewById, loading, refetch };
};

export const useDownloadDocument = () => {
  const getUrlFromData = (data: any) => {
    const filetype = data.getDocumentTemplatePreviewById.filetype as DocumentTypesEnum;
    const base64 = data.getDocumentTemplatePreviewById.base64;

    return `data:application/${FILETYPES[filetype]};base64,${base64}`;
  };

  const [downloadDocument, { loading }] = useLazyQuery(GET_DOCUMENT_TEMPLATE_PREVIEW_BY_ID, {
    onCompleted: data => {
      downloadCurrentTemplate(getUrlFromData(data), 'document');
    },
    fetchPolicy: 'no-cache',
  });

  return { downloadDocument, loading };
};
